import type { CodeActivity } from '../api';

function ago(days: number): string {
  if (days <= 0) return 'today';
  if (days < 60) return `${days}d ago`;
  return `${Math.floor(days / 30)}mo ago`;
}

/** "last commit 3d ago · PR #305 open" on a building idea, with a quiet "stalled" marker (P5-23). */
export function CodeActivityHint({ activity, className = '' }: { activity: CodeActivity | undefined; className?: string }) {
  if (!activity) return null;
  const parts: string[] = [];
  if (activity.days_since_commit !== null) parts.push(`last commit ${ago(activity.days_since_commit)}`);
  if (activity.pr) parts.push(`PR #${activity.pr.number} ${activity.pr.state}`);
  if (parts.length === 0 && !activity.stalled) return null;
  return (
    <span className={`code-hint ${className}`.trim()}>
      {activity.stalled && (
        <span className="code-hint-stalled">
          <span className="code-hint-dot" aria-hidden="true" />
          stalled
        </span>
      )}
      {parts.map((part, i) => (
        <span key={part} className="code-hint-part">{i > 0 ? `· ${part}` : part}</span>
      ))}
    </span>
  );
}
